"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.parseAndFormatUnixTime = exports.parseAndFormatISO = void 0;
var _dateFns = require("date-fns");
var _interfaces = require("../interfaces");
const parseAndFormatISO = (date, formatPattern, options) => {
  const parsedDate = (0, _interfaces.parseISO)(date);
  return (0, _dateFns.format)(parsedDate, formatPattern, options);
};
exports.parseAndFormatISO = parseAndFormatISO;
const parseAndFormatUnixTime = (timestamp, formatPattern, options) => {
  const parsedDate = (0, _interfaces.fromUnixTime)(timestamp);
  return (0, _dateFns.format)(parsedDate, formatPattern, options);
};
exports.parseAndFormatUnixTime = parseAndFormatUnixTime;